import React from 'react';
import {Card, Checkbox, Col, Form, Row, Typography} from 'antd';
import PropTypes from 'prop-types';

import {accountCreationCheckBoxError} from '../../helpers/text';

const {Text} = Typography;

const AccountPersonAddReview = ({firstName, lastName, email, birthDate, checked, setChecked, showCheckBoxError}) => {
    const [form] = Form.useForm();

    const onChange = (e) => {
        setChecked(e.target.checked);
    }

    // This element goes in different places depending on if it's an existing person without an email or a new person.
    const checkBoxJSX = (
        <>
            <Checkbox checked={checked} onChange={onChange}>
                I confirm that the information above is up to date and accurate.
            </Checkbox>
            {showCheckBoxError && accountCreationCheckBoxError}
        </>
    );

    return (
        <Form
            form={form}
            id="account-person-add-review"
            name="account-person-add-review"
        >
            <Card title={<span className="account-create-information-title">Profile Information</span>}>
                <Row>
                    <Col xs={24} md={4}>
                        <Text strong>First Name:</Text>
                    </Col>
                    <Col xs={24} md={20}>{firstName}</Col>
                </Row>
                <Row>
                    <Col xs={24} md={4}>
                        <Text strong>Last Name:</Text>
                    </Col>
                    <Col xs={24} md={20}>{lastName}</Col>
                </Row>
                <Row>
                    <Col xs={24} md={4}>
                        <Text strong>Birth Date:</Text>
                    </Col>
                    <Col xs={24} md={20}>{birthDate ? birthDate.format('DD MMM YYYY') : null}</Col>
                </Row>
            </Card>
            <br/>
            {!email ? checkBoxJSX : null}
            {!email ? <p className="check-box-additional-space"/> : null}
            <Card title={<span className="account-create-information-title">Login Information</span>}>
                <Row>
                    <Col xs={24} md={4}>
                        <Text strong>Email:</Text>
                    </Col>
                    <Col xs={24} md={20}>{email ? email : 'N/A'}</Col>
                </Row>
            </Card>
            <br/>
            {email ? checkBoxJSX : null}
        </Form>
    );
}

AccountPersonAddReview.propTypes = {
        firstName: PropTypes.string,
        lastName: PropTypes.string,
        birthDate: PropTypes.object,
        email: PropTypes.string,
        checked: PropTypes.bool,
        showCheckBoxError: PropTypes.bool,
};

export default AccountPersonAddReview;
